module.exports = __webpack_public_path__ + "static/media/ifttt_48.e952fe6c.svg";